import React, { useState, useEffect, useRef } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const InputComponent = ({
  label,
  value,
  onChange,
  variant,
  type = "text",
  inputProps = {},
  helperText,
  disableWheel = false,
  ...otherProps
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputRef = useRef(null);

  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  // Prevent mousewheel scroll from changing number input values
  useEffect(() => {
    const inputElement = inputRef.current;
    if (!inputElement) return;

    const input = inputElement.querySelector("input");

    if (input && (type === "number" || disableWheel)) {
      const preventScroll = (e) => {
        e.preventDefault();
      };

      input.addEventListener("wheel", preventScroll, { passive: false });

      return () => {
        input.removeEventListener("wheel", preventScroll);
      };
    }
  }, [type, disableWheel]);

  const finalType = type === "password" && showPassword ? "text" : type;

  return (
    <TextField
      ref={inputRef}
      label={label}
      value={value}
      onChange={onChange}
      variant={variant}
      type={finalType}
      fullWidth
      required
      helperText={helperText}
      InputProps={{
        endAdornment: type === "password" && (
          <IconButton
            onClick={togglePasswordVisibility}
            edge="end"
            aria-label="toggle password visibility"
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        ),
      }}
      inputProps={{
        ...inputProps,
        min: type === "number" ? inputProps.min || "0" : undefined,
      }}
      {...otherProps}
    />
  );
};

export default InputComponent;
